import { useState, ReactNode, FC } from 'react'
import SliderHeader from './SliderHeader'
import SliderBody from './SliderBody'

interface ComponentsProps {
  element: ReactNode
  name: string
  onClick?: () => void
}

interface SliderProps {
  components: ComponentsProps[]
  className?: string
  bodyClassName?: string
  initialStep?: number
  onClick?: ({ name, index }: { name: string; index: number }) => void
}

const Slider: FC<SliderProps> = ({
  components = [],
  className,
  bodyClassName,
  initialStep = 0,
  onClick,
}) => {
  const [currentChildIndex, setCurrentChildIndex] = useState(initialStep)
  const sliderClasses = [
    'grow',
    'h-full',
    'transition-all',
    'duration-500',
    'box-border',
    'overflow-x-hidden',
    className,
  ]

  if (components.length === 0) return null

  return (
    <div className={sliderClasses.join(' ')}>
      <SliderHeader
        {...{ components, currentChildIndex, setCurrentChildIndex, onClick }}
      />
      <SliderBody {...{ components, currentChildIndex, bodyClassName }} />
    </div>
  )
}

export default Slider
